<template>
	<div class="content">
		<div class="title">
			<span>专题学习 / </span>
			<span>{{detail.courseName}}</span>
		</div>
		<div class="content_con">
			<div class="con_top">
				<div class="top_left" :class="{ 'is-replay': showReplay }">
					<template v-if="sourcetype == 1">
						<video-player style="width: 100%;height: 100%" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
							:options="playerOptions" @play="onPlayerPlay($event,'play')" @pause="onPlayerPause($event,'pause')"
							@timeupdate="onPlayerTimeupdate($event,'timeupdate')" @ready="playerReadied($event)"
							@ended="onPlayerEnded($event)">
						</video-player>
					</template>
					<template v-if="sourcetype == 2">
						<img :src="imgUrl" style="width: 8.54rem;height: 4.3rem;"/>
						<div class="audio_play">
							<div class="control-btn" @click="playStatusChange">
								<div :class="playStatus ? 'play' : (showReplay ? 'replay' : 'stop')"></div>
							</div>
							<div class="control-line">
								<div ref="fullLine" class="bottom-line">
									<div class="played-line" :style="scaleProgress"></div>
									<div ref="point" class="play-point" @mousedown="handleMouseDown">
									<div class="point"></div>
								</div>
									<div class="played-time">{{ playTime }}</div>
								</div>
								<div class="al-time">{{ fullTime }}</div>
							</div>
							<div class="btn_volume">
								<div class="div_volume">
									<div ref="fullLine_v" class="bottom-line_v">
										<div class="played-line_v" :style="scaleProgress_v"></div>
										<div ref="point_v" class="play-point" @mousedown="handleMouseDown_v">
											<div class="point"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<audio ref="audio" @pause="onAudioPlayerPause" @play="onAudioPlayerPlay" style="display: none;"
							@timeupdate="onAudioPlayerTimeupdate" @canplay="computedFullTime" preload="auto" :src="audio.src"
							controls="controls" @ended="onAudioPlayerEnd"></audio>
					</template>
				</div>
				<div class="top_right">
					<template v-if="sourcetype == 1">
						<div class="right_title">
							目录（{{videoList.number}}）
						</div>
						<div class="right_con">
							<template v-for="(item,key) in videoList.resourcesName">
								<div class="con_item" @click="qiehuan(item)">
									<div class="con_item_left" :style="{ 'color': id == item.id ? '#0F81D3' : '' }">
										{{key+1}}.{{type == '1' ? item.gsrName : item.resourceName}}
										<div class="con_item_left_div">
											{{type == '1' ? formatTime(item.duration) : formatTime(item.resourceTimeLength)}}
										</div>
									</div>
									<img v-if="id != item.id && !isWatchedFinished(item)" class="con_item_img" src="../assets/video/bofang.png" />
									<img v-if="id == item.id && !isWatchedFinished(item)" class="con_item_img" src="../assets/video/bofanging.png" />
									<span v-if="isWatchedFinished(item)" class="con_item_img con_item_replay" :class="{ 'is-current': id == item.id }"></span>
								</div>
							</template>
						</div>
					</template>
					<template v-if="sourcetype == 2">
						<div class="right_title">
							目录（{{audioList.number}}）
						</div>
						<div class="right_con">
							<template v-for="(item,key) in audioList.resourcesName">
								<div class="con_item" @click="qiehuan(item)">
									<div class="con_item_left" :style="{ 'color': id == item.id ? '#0F81D3' : '' }">
										{{key+1}}.{{type == '1' ? item.gsrName : item.resourceName}}
										<div class="con_item_left_div">
											{{type == '1' ? formatTime(item.duration) : formatTime(item.resourceTimeLength)}}
										</div>
									</div>
									<img v-if="id != item.id && !isWatchedFinished(item)" class="con_item_img" src="../assets/video/bofang.png" />
									<img v-if="id == item.id && !isWatchedFinished(item)" class="con_item_img" src="../assets/video/bofanging.png" />
									<span v-if="isWatchedFinished(item)" class="con_item_img con_item_replay" :class="{ 'is-current': id == item.id }"></span>
								</div>
							</template>
						</div>
					</template>
				</div>
			</div>
			<div class="con_down">
				<div class="down_text">{{detail.courseName}}</div>
				<div class="down_line"></div>
				<div class="down_right">
					<!-- <img class="img_time" src="../assets/video/time.png" />
					学时：{{detail.classHour}} -->
					<img class="img_xuefen" src="../assets/video/xuefen.png" />
					学时：{{detail.credit}}
					<img class="img_time" src="../assets/video/time.png" />
					总时长：{{totalDuration}}
				</div>
				<div class="down_right" style="margin-left:100px;cursor: pointer;" @click="requestPictureInPicture">
					<i class="el-icon-news" style="margin-right:5px;"></i>
					开启画中画
				</div>

			</div>
		</div>

	</div>
</template>
<script>
	import {
		videoPlayer
	} from 'vue-video-player'
	import 'video.js/dist/video-js.css'
	import videojs from 'video.js'
	export default {
		components: {
			videoPlayer,
		},
		name: "",
		data() {
			return {
				id: 0,
				detailId: '',
				type: '',
				userId: 0,
				viewLink: "",
				autoplay: "",
				list: {},
				poster: "",
				detail: '',
				hasLogin: false,
				userInfo: '',
				videoList: {},
				playerOptions: {
					autoplay: false, // 如果为true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [],
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						progressControl: true, // 进度条 
						fullscreenToggle: true // 是否显示全屏按钮
					},
					width:'100%',
					height:'100%'
				},
				totalDuration: '', //总时长
				lastPlaybackPosition: '', //视频的上次播放时间
				sourcetype: '', //文件类型  1 视频  2 音频
				audio: {},
				audioList: {},
				nowSource: '',
				playStatus: false,
				scale: 0,
				playTime: '',
				fullTime: '',
				volume: 0.5,
				imgUrl: '',
				isPlay: false,
				showReplay: false,
				// inactivityTimer: null,//定时器
				_beforeUnloadHandler: null,
				_visibilityChangeHandler: null,
			};
		},
		computed: {
			scaleProgress() {
				if (this.scale) {
					return 'width:' + this.scale * 100 + '%';
				} else {
					return 'width:0';
				}
			},
			scaleProgress_v() {
				if (this.volume) {
					return 'width:' + this.volume * 100 + '%';
				} else {
					return 'width:0';
				}
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.detailId = this.$route.query.detailId;
			this.type = this.$route.query.type;
			this.sourcetype = this.$route.query.sourcetype;
			this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			if (this.userInfo != null && this.userInfo != undefined) {
				this.hasLogin = true;
			}
			
		},
		mounted() {
			videojs.addLanguage('zh-CN', {
			"You aborted the media playback": "视频播放被终止",
			"A network error caused the media download to fail part-way.": "网络错误导致视频下载中途失败。请刷新重试！",
			"The media could not be loaded, either because the server or network failed or because the format is not supported.": "视频因格式不支持或者服务器或网络的问题无法加载。请刷新重试！",
			"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。请刷新重试！",
			"No compatible source was found for this media.": "无法找到此视频兼容的源。",
			});
			this.getDetail();
			this._beforeUnloadHandler = (e) => this.beforeunloadHandler(e);
			this._visibilityChangeHandler = () => {
				if (document.visibilityState === 'hidden' && this.isPlay) {
					this.sendPlaybackData(2);
				}
			};
			window.addEventListener('beforeunload', this._beforeUnloadHandler);
			window.addEventListener('pagehide', this._beforeUnloadHandler);
			window.addEventListener('visibilitychange', this._visibilityChangeHandler);
		},
		beforeRouteLeave(to,from,next) {
			if (this.isPlay) {
				// try to reliably send current playback time when navigating away
				this.sendPlaybackTimeViaBeacon(1);
			}
			next();
		},
		methods: {
			getDetail() {
				let url = this.type == '1' ? '/blade-web/learn-subject/get-subject-info/' :
					'/user/CourseClassUserInfo/courseInfo/';
				this.$get(url + this.detailId, {})
					.then((res) => {
						console.log('详情', res);
						if (res.code == '200') {
							this.detail = res.data;
							if(this.type == '1'){
								this.imgUrl = JSON.parse(this.detail.coverAddress)[0].url;
							}else{
								this.imgUrl = JSON.parse(this.detail.coverAddress).link;
							}
							
							if (this.detail.courseContent.length > 0) {
								for (let i = 0; i < this.detail.courseContent.length; i++) {
									if (this.detail.courseContent[i].type == '视频资源') {
										this.videoList = this.detail.courseContent[i];
									}
									if (this.detail.courseContent[i].type == '音频资源') {
										this.audioList = this.detail.courseContent[i];
									}
								}
								let timeList = [];
								if (this.sourcetype == 1) {
									for (let i = 0; i < this.videoList.resourcesName.length; i++) {
										if (this.videoList.resourcesName[i].gsrId) {
											this.videoList.resourcesName[i].id = this.videoList.resourcesName[i].gsrId;
										}
										if (this.type == '1') {
											timeList.push(this.videoList.resourcesName[i].duration)
										} else {
											timeList.push(this.videoList.resourcesName[i].resourceTimeLength)
										}
										if (this.id == this.videoList.resourcesName[i].id) {
											let video = '';
											if (this.type == '1') {
												let srcType = this.videoList.resourcesName[i].fileUrl.substring(this.videoList.resourcesName[i].fileUrl.lastIndexOf(".")+1)
												video = {
													src: this.videoList.resourcesName[i].fileUrl, // 路径
													type: 'video/' + srcType // 类型
												};
											} else {
												let srcType = JSON.parse(this.videoList.resourcesName[i].coverAddress).link.substring(JSON.parse(this.videoList.resourcesName[i].coverAddress).link.lastIndexOf(".")+1)
												video = {
													src: JSON.parse(this.videoList.resourcesName[i].coverAddress).link, // 路径
													type: 'video/' + srcType // 类型
												};
											}
											this.playerOptions.sources.push(video);
											this.lastPlaybackPosition = this.videoList.resourcesName[i].lastPlaybackPosition;
											this.showReplay = this.isWatchedFinished(this.videoList.resourcesName[i]);
											console.log(123,this.lastPlaybackPosition)
										}
									}
								}
								if (this.sourcetype == 2) {
									for (let i = 0; i < this.audioList.resourcesName.length; i++) {
										if (this.audioList.resourcesName[i].gsrId) {
											this.audioList.resourcesName[i].id = this.audioList.resourcesName[i].gsrId;
										}
										if (this.type == '1') {
											timeList.push(this.audioList.resourcesName[i].duration)
										} else {
											timeList.push(this.audioList.resourcesName[i].resourceTimeLength)
										}
										if (this.id == this.audioList.resourcesName[i].id) {
											let audio = '';
											if (this.type == '1') {
												audio = {
													src: this.audioList.resourcesName[i].fileUrl, // 路径
												};
											} else {
												audio = {
													src: JSON.parse(this.audioList.resourcesName[i].coverAddress).link, // 路径
												};
											}
											this.audio = audio;
											this.nowSource = this.audio.src;
											this.lastPlaybackPosition = this.audioList.resourcesName[i].lastPlaybackPosition;
											this.showReplay = this.isWatchedFinished(this.audioList.resourcesName[i]);
										}
									}
								}
								sessionStorage.setItem('currentTime' + this.id, this.lastPlaybackPosition);
								this.getVideoDuration(timeList);
							}
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
				
				//学习次数
				this.$post('/blade-web/learn-subject/learn-learn-num',{
					resourcesId: this.detailId
				}).then(res => {
					console.log('学习次数',res)
				})
			},
			qiehuan(obj) {
				this.playerOptions.sources = [];
				this.id = obj.id;
				if (this.sourcetype == 1) {
					let video = '';
					if (this.type == '1') {
						let srcType = obj.fileUrl.substring(obj.fileUrl.lastIndexOf(".")+1)
						video = {
							src: obj.fileUrl, // 路径
							type: 'video/' + srcType // 类型
						};
					} else {
						let srcType = JSON.parse(obj.coverAddress).link.substring(JSON.parse(obj.coverAddress).link.lastIndexOf(".")+1)
						video = {
							src: JSON.parse(obj.coverAddress).link, // 路径
							type: 'video/' + srcType // 类型
						};
					}
					this.playerOptions.sources.push(video);
					this.nowSource = this.playerOptions.sources[0].src;
				}
				if (this.sourcetype == 2) {
					let audio = '';
					if (this.type == '1') {
						audio = {
							src: obj.fileUrl, // 路径
						};
					} else {
						audio = {
							src: JSON.parse(obj.coverAddress).link, // 路径
						};
					}
					this.audio = audio;
					this.nowSource = this.audio.src;
				}
				this.lastPlaybackPosition = obj.lastPlaybackPosition;
				this.showReplay = this.isWatchedFinished(obj);

				console.log(this.lastPlaybackPosition, this.audio, obj)
			},
			//计算总时长
			getVideoDuration(list) {
				let sum = 0;
				let hour = 0;
				let minu = 0;
				let seco = 0;
				for (let i = 0; i < list.length; i++) {
					sum += parseInt(list[i]);
				}
				hour = parseInt(sum / 3600);
				minu = parseInt(sum % 3600 / 60);
				seco = parseInt(sum % 60);
				if (hour < 10) {
					hour = '0' + hour;
				}
				if (minu < 10) {
					minu = '0' + minu;
				}
				if (seco < 10) {
					seco = '0' + seco;
				}
				this.totalDuration = hour + ':' + minu + ':' + seco;
				console.log(hour, minu, seco)
			},
			putLearningObj(type) {
				//   向后台传值
				let _this = this
				let time = sessionStorage.getItem('currentTime' + this.id)
				let chazhi = time - this.lastPlaybackPosition;
				let obj = {
					usersId: this.userInfo.user_id,
					resourcesId: this.id,
					lastPlaybackLength: time,
					totalTime: type == 1 ? chazhi : 0,
					flag: this.sourcetype == 1 ? 0 : 1
				}
				let url = this.type == '1' ? '/blade-web/learn-subject/user-watch-record' :
					'/user/CourseClassUserInfo/savePayLength';
				this.$post(url, obj)
					.then(res => {
						console.log('保存数据', res);
						if(type == 1){
							this.lastPlaybackPosition = time
						}else{
							this.lastPlaybackPosition = 0
							sessionStorage.setItem('currentTime' + this.id, 0);
						}
					})
			},
			onPlayerEnded(player) {
				// 向后台传值  
				console.log(this.durations, player)
				this.markCurrentFinished();
				this.showReplay = true;
				setTimeout(() => {
					this.putLearningObj(2)
				},500)
			},
			onPlayerPlay(player) {
				this.isPlay = true;
				if (this.showReplay) {
					player.currentTime(0);
					sessionStorage.setItem('currentTime' + this.id, 0);
					this.lastPlaybackPosition = 0;
				}
				this.showReplay = false;
				document.querySelector(".vjs-progress-control").style.pointerEvents ="none";
				console.log('player play!', player)
				// this.resetInactivityTimer();
			},
			onPlayerPause(player) {
				console.log('player pause!', this.durations, player)
				// 向后台存播放时间
				this.putLearningObj(1)
			},
			onPlayerTimeupdate(player) {
				this.durations = player.cache_.currentTime
				sessionStorage.setItem('currentTime' + this.id, this.durations);
			},
			// player is ready
			playerReadied(player) {
				// // 从后台获取视频播放时间
				let _this = this
				if (this.showReplay) {
					player.currentTime(0);
					return;
				}
				let time = sessionStorage.getItem('currentTime' + this.id)
				if (time) {
					player.currentTime(time)
				} else {
					player.currentTime(this.lastPlaybackPosition)
				}
			},
			audioPlayerReadied() {
				// // 从后台获取视频播放时间
				let _this = this
				let time = sessionStorage.getItem('currentTime' + this.id)
				if (time) {
					this.$refs.audio.currentTime = time;
				} else {
					this.$refs.audio.currentTime = this.lastPlaybackPosition;
				}
				this.scale = this.$refs.audio.currentTime / this.$refs.audio.duration;
				this.playTime = this.formatTime(this.$refs.audio.currentTime);
				console.log(this.scale, this.playTime, this.fullTime)
			},
			onAudioPlayerPlay(player) {
				console.log("你的播放开启了");
				this.isPlay = true;
				if (this.showReplay) {
					this.$refs.audio.currentTime = 0;
					sessionStorage.setItem('currentTime' + this.id, 0);
					this.lastPlaybackPosition = 0;
				}
				this.showReplay = false;
				//保存当前播放资源
				this.audioPlayerReadied()
				// this.resetInactivityTimer();
			},
			computedFullTime() {
				this.playTime = this.formatTime(this.$refs.audio.currentTime);
				this.fullTime = this.formatTime(this.$refs.audio.duration);
				console.log(this.playTime, this.fullTime)
			},
			onAudioPlayerTimeupdate(player) {
				console.log(this.nowSource, player)
				if (this.nowSource == player.target.currentSrc) {
					this.durations = player.target.currentTime
					sessionStorage.setItem('currentTime' + this.id, this.durations);
				}
				this.scale = this.$refs.audio.currentTime / this.$refs.audio.duration;
				this.playTime = this.formatTime(this.$refs.audio.currentTime);
			},
			onAudioPlayerPause(player) {
				console.log('player pause!', this.durations, player)
				// 向后台存播放时间
				this.playStatus = false;
				this.putLearningObj(1)
			},
			onAudioPlayerEnd(player) {
				console.log('player end!', this.durations, player)
				this.markCurrentFinished();
				this.showReplay = true;
				this.playStatus = false;
				// 向后台存播放时间
				setTimeout(() => {
					this.putLearningObj(2)
				},500)
			},
			playStatusChange() {
				if (this.showReplay && !this.playStatus) {
					this.replayCurrent();
					return;
				}
				this.playStatus = !this.playStatus;
				if (this.playStatus) {
					this.$refs.audio.play();
				} else {
					this.$refs.audio.pause();
				}
			},
			getResourceDuration(item) {
				if (!item) {
					return 0;
				}
				return Number(this.type == '1' ? item.duration : item.resourceTimeLength) || 0;
			},
			isWatchedFinished(item) {
				const total = this.getResourceDuration(item);
				const watched = Number(item && item.lastPlaybackPosition) || 0;
				if (total <= 0) {
					return false;
				}
				return watched >= total;
			},
			markCurrentFinished() {
				const list = this.sourcetype == 1 ? this.videoList.resourcesName : this.audioList.resourcesName;
				if (!list || !list.length) {
					return;
				}
				for (let i = 0; i < list.length; i++) {
					if (list[i].id == this.id) {
						const total = this.getResourceDuration(list[i]);
						this.$set(list[i], 'lastPlaybackPosition', total || list[i].lastPlaybackPosition);
						break;
					}
				}
			},
			replayCurrent() {
				sessionStorage.setItem('currentTime' + this.id, 0);
				this.lastPlaybackPosition = 0;
				this.showReplay = false;
				this.isPlay = true;
				if (this.sourcetype == 1 && this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
					this.$refs.videoPlayer.player.currentTime(0);
					this.$refs.videoPlayer.player.play();
				}
				if (this.sourcetype == 2 && this.$refs.audio) {
					this.$refs.audio.currentTime = 0;
					this.playStatus = true;
					this.$refs.audio.play();
				}
			},
			formatTime(num) {
				let hour = parseInt(num / 3600);
				let minu = parseInt(num % 3600 / 60);
				let seco = parseInt(num % 60);

				if (hour < 10) {
					hour = '0' + hour;
				}
				if (minu < 10) {
					minu = '0' + minu;
				}
				if (seco < 10) {
					seco = '0' + seco;
				}
				return hour + ':' + minu + ':' + seco;
			},
			async beforeunloadHandler(e) {
				// mark for debugging
				sessionStorage.setItem('进入事件2', 2);
				if (this.isPlay) {
					// use beacon/fallback to send final playback data
					this.sendPlaybackTimeViaBeacon(2);
				}
			},

			// wrapper used by visibilitychange handler
			sendPlaybackData(type) {
				this.sendPlaybackTimeViaBeacon(type);
			},

			// send playback info using navigator.sendBeacon with fallbacks
			sendPlaybackTimeViaBeacon(type) {
				try {
					const key = 'currentTime' + this.id;
					const timeRaw = sessionStorage.getItem(key) || 0;
					const time = Number(timeRaw);
					const chazhi = time - (this.lastPlaybackPosition || 0);
					const obj = {
						usersId: this.userInfo ? this.userInfo.user_id : 0,
						resourcesId: this.id,
						lastPlaybackLength: time,
						totalTime: type == 1 ? chazhi : 0,
						flag: this.sourcetype == 1 ? 0 : 1
					};
					const url = this.type == '1' ? '/api/blade-web/learn-subject/user-watch-record' : '/api/user/CourseClassUserInfo/savePayLength';



					// Use sendBeacon when available (best for unload)
					if (navigator && typeof navigator.sendBeacon === 'function') {
						const blob = new Blob([JSON.stringify(obj)], { type: 'application/json' });
						try {
							return navigator.sendBeacon(url, blob);
						} catch (err) {
							console.error('sendBeacon failed', err);
						}
					}

					// Fallback to fetch with keepalive (may work in modern browsers)
					if (typeof fetch === 'function') {
						try {
							fetch(url, {
								method: 'POST',
								headers: { 'Content-Type': 'application/json' },
								body: JSON.stringify(obj),
								keepalive: true,
								mode: 'same-origin'
							});
							return true;
						} catch (e) {
							console.error('fetch keepalive failed', e);
						}
					}

					// Last-resort synchronous XHR (will block briefly)
					try {
						const xhr = new XMLHttpRequest();
						xhr.open('POST', url, false);
						xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
						xhr.send(JSON.stringify(obj));
						return true;
					} catch (err) {
						console.error('sync XHR failed', err);
					}
				} catch (err) {
					console.error('sendPlaybackTimeViaBeacon error', err);
				}
			},
			//鼠标按下事件触发
			handleMouseDown(ev) {
				const that = this;
				const downX = ev.pageX;
				const downL = this.$refs.point.offsetLeft;
				//鼠标移动事件
				document.onmousemove = ev => {
					let scale =
						(ev.pageX - downX + downL + 8) / that.$refs.fullLine.offsetWidth;
					if (scale < 0) {
						scale = 0;
					} else if (scale > 1) {
						scale = 1;
					}
					that.scale = scale;
					that.$refs.audio.currentTime = scale * that.$refs.audio.duration;
					that.playTime = that.formatTime(that.$refs.audio.currentTime);
				};
				document.onmouseup = () => {
					document.onmousemove = document.onmouseup = null;
				};
				ev.preventDefault();
			},
			handleMouseDown_v(ev) {
				const that = this;
				const downY = ev.pageY;
				const downL = this.$refs.point_v.offsetLeft;
				//鼠标移动事件
				document.onmousemove = ev => {
					console.log(ev.pageX,ev.pageY)
					let volume =
						(downY - ev.pageY + downL + 8) / that.$refs.fullLine_v.offsetWidth;
					if (volume < 0) {
						volume = 0;
					} else if (volume > 1) {
						volume = 1;
					}
					that.volume = volume;
					that.$refs.audio.volume = that.volume;
				};
				document.onmouseup = () => {
					document.onmousemove = document.onmouseup = null;
				};
				ev.preventDefault();
			},
			// async resetInactivityTimer() {
			// 	// 如果定时器已经存在，清除它
			// 	if (this.inactivityTimer) {
			// 		clearTimeout(this.inactivityTimer);
			// 	}
			// 	// 设置新的延迟时间
			// 	const inactivityDelay = 15 * 60 * 1000; 
			// 	this.inactivityTimer = await setTimeout(this.pauseIfInactive, inactivityDelay);
			// },
			// pauseIfInactive() {
			// 	// 当播放器处于活动状态时暂停播放
			// 	if (this.isPlay) {
			// 		this.$refs.videoPlayer.player.pause();
			// 	}
			// },
			async requestPictureInPicture () {
				if (document.getElementsByTagName('video') && document.getElementsByTagName('video').length > 0) {
					try {
						await document.getElementsByTagName('video')[0].requestPictureInPicture();
					} catch (error) {
						console.error('画中画请求失败', error);
					}
				}
			},


		},
		beforeDestroy() {
			// 清除定时器，防止内存泄漏
			if (this.inactivityTimer) {
				clearTimeout(this.inactivityTimer);
			}
			// 移除页面事件监听
			if (this._beforeUnloadHandler) {
				window.removeEventListener('beforeunload', this._beforeUnloadHandler);
				window.removeEventListener('pagehide', this._beforeUnloadHandler);
			}
			if (this._visibilityChangeHandler) {
				window.removeEventListener('visibilitychange', this._visibilityChangeHandler);
			}
		},
		destroyed() {
			// listeners already removed in beforeDestroy
		},
	};
</script>
<style scoped lang="less">
	::-webkit-scrollbar {
		width: 6px;
	}

	/*  滚动条轨道 */
	::-webkit-scrollbar-track {
		background-color: rgba(30, 53, 81, 0.4);
	}

	/*  滚动条上的滚动滑块 */
	::-webkit-scrollbar-thumb {
		background-color: rgba(211, 211, 211, 0.7);
		border-radius: 4px;
	}
	/deep/ .vjs-progress-control{
	  pointer-events: none !important;
	 }
	/deep/ .is-replay .video-js .vjs-big-play-button .vjs-icon-placeholder:before,
	/deep/ .video-js.vjs-ended .vjs-big-play-button .vjs-icon-placeholder:before {
		content: "\f116" !important;
		font-family: VideoJS !important;
	}
	.content {
		background-color: #EBEFF1;
		padding-bottom: 0.3rem;
		padding-left: 1.2rem;
		padding-right: 1.2rem;
	}

	.title {
		width: 12rem;
		height: 0.6rem;
		color: #000000;
		font-size: 0.15rem;
		font-weight: 400;
		font-family: Alibaba PuHuiTi;
		display: flex;
		align-items: center;
	}

	.title span:first-child {
		color: #cccccc;
	}

	.content_con {
		width: 100%;
		height: 100%;
		background: #1E3551;
	}

	.con_top {
		display: flex;

		.top_left {
			width: 8.54rem;
			min-height: 4.8rem;
			position: relative;
		}
		.top_right {
			width: 3.46rem;
			height: 4.8rem;
			display: flex;
			flex-direction: column;

			.right_title {
				color: #a4b3c4;
				font-family: Alibaba PuHuiTi;
				font-size: 0.20rem;
				font-weight: 700;
				margin: 0.2rem 0 0.2rem 0.3rem;
			}

			.right_con {
				overflow-y: auto;
				flex: 1;

				.con_item {
					height: 0.4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding-left: 0.24rem;
					padding-right: 0.3rem;
					margin-bottom: 0.2rem;
					cursor: pointer;

					.con_item_left {
						color: #a4b3c4;
						font-family: Alibaba PuHuiTi;
						font-size: 0.16rem;
						font-weight: 700;

						.con_item_left_div {
							font-size: 0.14rem;
							text-indent: 1em;
						}
					}

					.con_item_img {
						width: 0.31rem;
						height: 0.21rem;
					}
					.con_item_replay {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						background: #D8DCE3;
						border-radius: 0.06rem;
						color: #ffffff;
					}
					.con_item_replay:before {
						content: "\f116";
						font-family: VideoJS;
						font-size: 0.16rem;
						line-height: 1;
					}
					.con_item_replay.is-current {
						background: #2B8CFF;
					}
				}
			}
		}
	}

	.con_down {
		width: 100%;
		height: 0.75rem;
		color: #a4b3c4;
		font-family: Alibaba PuHuiTi;
		font-size: 0.20rem;
		display: flex;
		align-items: center;
		padding-left: 0.2rem;
		.down_text{
			display: inline-block;
			width: 2.6rem;
			white-space: nowrap;       /* 不换行 */
			overflow: hidden;          /* 隐藏溢出部分 */
			text-overflow: ellipsis;   /* 超出部分显示省略号 */
		}
		.down_line {
			width: 1px;
			height: 0.16rem;
			background: #A4B3C4;
			margin-left: 0.3rem;
		}

		.down_right {
			color: #a4b3c4;
			font-family: Alibaba PuHuiTi;
			font-size: 0.14rem;
			font-weight: 400;
			display: flex;
			align-items: center;
		}

		.img_time {
			width: 0.13rem;
			height: 0.13rem;
			margin-left: 0.3rem;
			margin-right: 0.04rem;
		}

		.img_xuefen {
			width: 0.12rem;
			height: 0.12rem;
			margin-left: 0.3rem;
			margin-right: 0.04rem;
		}
	}
	.audio_play{
		display: flex;height: 0.54rem;position: absolute;bottom: 0;left: 0;align-items: center;
		.control-btn {
			height: 0.54rem;
			width: 0.54rem;
			display: flex;
			justify-content: center;
			align-items: center;
			.play {
				height: 0.34rem;
				width: 0.34rem;
				background: url('../assets/video/pause.png') no-repeat center;
				background-size: 100%;
			}

			.stop {
				height: 0.34rem;
				width: 0.34rem;
				background: url('../assets/video/play.png') no-repeat center;
				background-size: 100%;
			}
			.replay {
				height: 0.34rem;
				width: 0.34rem;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #2080f7;
			}
			.replay:before {
				content: "\f116";
				font-family: VideoJS;
				font-size: 0.3rem;
				line-height: 1;
			}
		}

		.control-line {
			width: 7.2rem;
			margin-left: 0.1rem;

			.al-time {
				float: right;
				opacity: 0.6;
				font-family: PingFangSC-Semibold;
				font-size: 0.12rem;
				color: #78aaff;
				margin-top: 0.04rem;
			}

			.bottom-line {
				display: flex;
				position: relative;
				margin-top: 0.2rem;
				height: 0.06rem;
				width: 7.2rem;
				background: rgba(5, 124, 255, 0.13);
				border-radius: 0.03rem;

				.played-line {
					background-image: linear-gradient(90deg, #43b7fc 0%, #2080f7 93%);
					border-radius: 0.03rem;
					height: 0.06rem;
				}

				.played-time {
					position: absolute;
					opacity: 0.6;
					font-family: PingFangSC-Semibold;
					font-size: 0.12rem;
					color: #78aaff;
					left: -0.08rem;
					top: 0.10rem;
				}

				.play-point {
					position: relative;
					height: 0.10rem;
					width: 0.10rem;
					background: #ffffff;
					border: 0.01rem solid #2080f7;
					border-radius: 0.05rem;
					margin-left: -0.05rem;
					margin-top: -0.03rem;
					pointer-events: none;
					.point {
						background: #7fbcff;
						height: 0.04rem;
						width: 0.04rem;
						margin: 0.03rem;
						border-radius: 0.02rem;
					}
				}
			}
		}
		.btn_volume{
			position: relative;
			width: 0.34rem;
			height: 0.34rem;
			background: url('../assets/video/volume.png') no-repeat center;
			background-size: 100%;
			margin-left: 0.12rem;
		}
		.btn_volume:hover .div_volume{
			display: block;
		}
		.div_volume{
			transform: rotate(-90deg);width: 100px;height: 60px;position: absolute;bottom: 0.7rem;right: -0.1rem;display: none;
		}
		.bottom-line_v {
			display: flex;
			position: relative;
			margin-top: 0.2rem;
			height: 0.06rem;
			width: 100px;
			background: rgba(5, 124, 255, 0.13);
			border-radius: 0.03rem;
		
			.played-line_v {
				background-image: linear-gradient(90deg, #43b7fc 0%, #2080f7 93%);
				border-radius: 0.03rem;
				height: 0.06rem;
			}
			.play-point {
				position: relative;
				height: 0.10rem;
				width: 0.10rem;
				background: #ffffff;
				border: 0.01rem solid #2080f7;
				border-radius: 0.05rem;
				margin-left: -0.05rem;
				margin-top: -0.03rem;
				pointer-events: none;
				.point {
					background: #7fbcff;
					height: 0.04rem;
					width: 0.04rem;
					margin: 0.03rem;
					border-radius: 0.02rem;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/index/VideoPlayback.vue